import * as React from 'react';
import TwoColRow from './TwoColRow';
import { Hr, Paragraph } from '../../../../elements';
const ChildrenRow = ({ value, i18n, formatDate }) => {
    var _a;
    return (React.createElement(React.Fragment, null,
        React.createElement(TwoColRow, { className: 'HeadingSpace', label: i18n('common.totalChild'), value: value.yearOfBirth ? value.yearOfBirth.length : '0' }), (_a = value === null || value === void 0 ? void 0 : value.yearOfBirth) === null || _a === void 0 ? void 0 :
        _a.map((item, index) => (React.createElement(React.Fragment, { key: index },
            React.createElement(TwoColRow, { label: i18n('common.yearOfBirth'), value: item })))),
        React.createElement(Hr, null),
        React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('stateauthority.taxAgency')} (${formatDate(value.verificationDate)})` }),
        value.comment !== '' && (React.createElement("div", { className: 'ReadReportContent__Notation ReadReportContent__Space--large' },
            React.createElement(Paragraph, { bold: true }, i18n('common.note')),
            React.createElement("div", { className: 'ReadReportContent__NotationContent' },
                React.createElement(Paragraph, { className: 'ReadReportContent__Space--semi-medium ReadReportContent__Space--scroll-overflow' }, value.comment))))));
};
export default ChildrenRow;
